import apiClient from '@/services/api-client';

export default {
	getComposerUrl() {
		return apiClient().get('/SocialMarketing/composerurl');
	},
	getCalendarUrl() {
		return apiClient().get('/SocialMarketing/calendarurl');
	},
	getAnalyticsUrl() {
		return apiClient().get('/SocialMarketing/analyticsurl');
	},
	getSettingsUrl() {
		return apiClient().get('/SocialMarketing/settingsurl');
	},
};
